

document.addEventListener('DOMContentLoaded', () => {
    const storedURL = localStorage.getItem('diagnosticResult');
    const placeholderPath = '/diagnostic-result';
    const textBtn = document.querySelector(`a.wt-page-nav-mega__link[href="${placeholderPath}"] span`).innerText;

    const links = document.querySelectorAll(`a[href="${placeholderPath}"]`);
    if (storedURL) {
        links.forEach((link) => {
            link.style.display = "display";
            link.href = storedURL;
            link.querySelector('span').innerText = textBtn;
            link.classList.add('hero__button--primary', 'cta-diagnostic');
            
        });
    }
});